import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApplyCSS from '../../../../components/ApplyCSS';
import TextInput from '../../../../components/ZUILib/TextInput';
import { _handleUserRegistration } from './../../../Accounts/createAccount/actions';
import RadioButton from '../../../../components/ZUILib/RadioButton';
import InputButton from '../../../../components/ZUILib/InputButton';
import CalenderSample from '../../../../components/ZUILib/CalenderSample';
import commonUtil from '../../../../utils/commonUtil';
import CheckBox from '../../../../components/ZUILib/CheckBox';
import errorLables from '../../../../utils/errors/LP_GR_error.json';

class SignUp extends Component {
  handleCreateAccount = () => {
    if (this.validate()) {
      this.props._handleUserRegistration(this.userRegistration);
    }
  }
  constructor(props) {
    super(props);
    this.userRegistration = {
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      maternalName: '',
      bdayDAY: '',
      bdayMONTH: '',
      bdayYEAR: '',
      gender: '',
      channel: '',
      brandName: '',
      autoLoginCheckbox: '',
    };
  }
  handleSelectedGender = (selectedGender) => {
    if (selectedGender) {
      this.gender = selectedGender.value;
    }
  }
  openTermAndCondition = () => {
    window.open('https://assetspwa.liverpool.com.mx/ayuda/index.html#/sec/terminos-y-condiciones/proteccion-de-datos/aviso-clientes');
  }
  validate = () => {
    const emailValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.email.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.email.required') },
        { functionRef: commonUtil.validateEmail, funcData: [this.email.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.email.invalid') },
    ];

    const firstNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.firstName.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.firstName.required') },
        { functionRef: commonUtil.validateName, funcData: [this.firstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.firstName.invalid') },
    ];

    const lastNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.lastName.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.lastName.required') },
        { functionRef: commonUtil.validateName, funcData: [this.lastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.lastName.invalid') },
    ];

    const passwordValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.password.required') },
        { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.password.invalid') },
    ];

    const isEmailValid = commonUtil.validateTextInput(emailValidationRules, this.email, null);
    const isFirstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.firstName, null);
    const isLastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.lastName, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRules, this.password, null);

    let isMaternalNameValid = true;
    if (this.maternalName.getValue()) {
      const maternalNameValidationRules = [
          { functionRef: commonUtil.isValueAvailable, funcData: [this.maternalName.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.maternamlName.required') },
          { functionRef: commonUtil.validateName, funcData: [this.lastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.maternalName.invalid') },
      ];
      isMaternalNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.maternalName, null);
    }

    let dateValidationRules = '';
    let isdateValid = true;
    let tempDate = [];
    if (this.birthDate.state.date) {
      dateValidationRules = {
        functionRef: commonUtil.isValueAvailable, funcData: [this.birthDate.state.date], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.registration.date.required'),
      };
      isdateValid = commonUtil.validateCalendarInput(dateValidationRules, this.birthDate, null);
      if (isdateValid) {
        tempDate = this.date.split('/');
      }
    }

    if (isEmailValid && isPasswordValid && isFirstNameValid && isLastNameValid && isMaternalNameValid) {
      this.userRegistration.email = this.email.getValue();
      this.userRegistration.password = this.password.getValue();
      this.userRegistration.firstName = this.firstName.getValue();
      this.userRegistration.lastName = this.lastName.getValue();
      this.userRegistration.maternalName = this.maternalName.getValue();
      this.userRegistration.bdayDAY = tempDate[0];
      this.userRegistration.bdayMONTH = tempDate[1];
      this.userRegistration.bdayYEAR = tempDate[2];
      this.userRegistration.gender = this.gender;
      this.userRegistration.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }

    const { email, password, firstName, lastName } = this.userRegistration;
    if (email && password && firstName && lastName) {
      return true;
    }
    return false;
  }
  toggleRemeberMeMessage = () => {
    const autologinTooltip = document.querySelector('.' + this.autoSignUpWAP.className);
    if (autologinTooltip.style.display === 'none') {
      autologinTooltip.style.display = 'block';
    } else {
      autologinTooltip.style.display = 'none';
    }
  }
  render() {
    const pageName = 'createCoOnwerAccount';
    const { lables } = this.props;

    const _genders = {
      htmlId: 'gender',
      title: commonUtil.getLabel(lables.createLogin, 'create.account.sexo.label'),
      displayName: commonUtil.getLabel(lables.createLogin, 'create.account.sexo.label'),
      name: 'gender',
      defaultValue: 'hombre',
      options: [
        {
          id: 'radio1',
          value: 'male',
          title: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          displayName: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          labelResourceId: commonUtil.getLabel(lables.createLogin, 'create.account.gender.male'),
          selected: true,
        },
        {
          id: 'radio2',
          value: 'female',
          title: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
          displayName: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
          labelResourceId: commonUtil.getLabel(lables.createLogin, 'create.account.gender.female'),
        },
      ],
    };

    const rememberMeCheckBoxConfig = {
      displayName: commonUtil.getLabel(lables.createLogin, 'login.keep.me.login'),
      id: 'signupchk',
      name: '',
      value: '',
      disabled: '',
    };

    const textInputAttr = {
      textClassName: 'form-control',
      textPlaceholder: commonUtil.getLabel(lables.createLogin, 'create.account.dob.label'),
    };

      // json for button Create Account
    const createAccountButton = {
      type: 'button',
      value: 'Aceptar',
      autoFocus: false,
      style: 'btnPrimary size-Full',
      onClickHandler: this.handleCreateAccount,
    };
    const currentDate = new Date();
    const startDate = new Date('january 01, 1900');
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div className="borderTop createAccountGR" id="createEvent">
          <div className="row">
            <div className="col-xs-12 col-md-10 col-md-offset-1">
              <div className="registerTitles">
                <h2 className="registerGiftTitle">{commonUtil.getLabel(lables.createLogin, 'create.account.lable')}</h2></div>
              <div className="row requiredFields pull-right">
                <div className="col-xs-12"><span>{commonUtil.getLabel(lables.createLogin, 'createLogin.mandatory.fields.message')}</span></div>
              </div>
              <div className="row createForm">
                <div className="col-xs-12">
                  <form>
                    <div className="formBlock">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="correo"
                        label={commonUtil.getLabel(lables.createLogin, 'create.account.email')}
                        name="Correo"
                        maxlength="100"
                        required="true"
                        star="*"
                        ref={email => this.email = email}
                      />
                    </div>
                    <div className="formBlock">
                      <TextInput
                        type="password"
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="Contraseña"
                        label={commonUtil.getLabel(lables.createLogin, 'create.account.password')}
                        name="Contraseña"
                        required="true"
                        star="*"
                        ref={password => this.password = password}
                      />
                    </div>
                    <div className="formBlock">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="nombre"
                        label={commonUtil.getLabel(lables.createLogin, 'create.account.name')}
                        name="Nombre"
                        maxlength="100"
                        required="true"
                        star="*"
                        ref={firstName => this.firstName = firstName}
                      />
                    </div>
                    <div className="formBlock">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="apellidoPaterno"
                        label={commonUtil.getLabel(lables.createLogin, 'create.account.paternal.name')}
                        name="Apellido Paterno"
                        maxlength="100"
                        required="true"
                        star="*"
                        ref={lastName => this.lastName = lastName}
                      />
                    </div>
                    <div className="formBlock">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="apellidomaterno"
                        label={commonUtil.getLabel(lables.createLogin, 'create.account.maternal.name')}
                        maxlength="100"
                        name="Apellido Materno"
                        required="true"
                        ref={maternalName => this.maternalName = maternalName}
                      />
                    </div>
                    <div className="formBlock">
                      <div className="materialStyle">
                        <div className="inputDate input-group date datetimepicker" id="datetimepicker1">
                          <CalenderSample
                            textInputJSON={textInputAttr}
                            getCalenderDate={this._setDate}
                            activeStartDate={currentDate}
                            minDate={startDate}
                            maxDate={currentDate}
                            viewType="decade"
                            ref={(e) => { this.birthDate = e; }}
                            onChangeHandler={date => this.date = date}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row genderRadios">
                      <div className="col-xs-3" name="gender"><label>{commonUtil.getLabel(lables.createLogin, 'create.account.sexo.label')}</label></div>
                      <div className="col-xs-9 text-right">
                        {_genders.options.map(option => (
                          <RadioButton
                            displayName={option.displayName}
                            id={option.id}
                            value={option.value}
                            title={option.title}
                            radioCssClass={'radio'}
                            name={_genders.name}
                            onChangeFunction={this.handleSelectedGender}
                            selected={this.userRegistration.gender ? this.userRegistration.gender === option.value : false}
                          />))}
                      </div>
                    </div>
                    {/* eslint-disable */}
                    <div className="row">
                      <div className="col-xs-12 p-l-35">
                        <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.id} ref={(e) => { this.userAutoLogingChk = e; }}>
                          <a className="p-l-15" onClick={this.toggleRemeberMeMessage}>{commonUtil.getLabel(lables.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
                          <div className="homeSessionContainer" ref={e => this.autoSignUpWAP = e} style={{ display: 'none' }}>
                          <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                          <hr />
                          <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content1')}</p>
                          <p>{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content2')}</p>
                          </div>
                        </CheckBox>
                      </div>
                    </div>
                    <p className="termCondition">{commonUtil.getLabel(lables.createLogin, 'create.account.terms.cndition.msg')}
                      <a className="linkTermCondition" onClick={this.openTermAndCondition}>{commonUtil.getLabel(lables.createLogin, 'create.account.terms.cndition.label')}</a>
                      <span className="terms_promos" style={{ color: '#000' }}> {commonUtil.getLabel(lables.createLogin, 'create.account.after.terms.cndition.msg')}</span>
                    </p>
                    <InputButton buttonAttr={createAccountButton} />
                  </form>
                  <div>
                    <h2 className="registerGiftTitle">{commonUtil.getLabel(lables.createLogin, 'create.account.benefit.title.msg')}</h2>
                    <ul dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.createLogin, 'create.account.benefits') }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  }
const mapStateToProps = state => ({
  user: state.user,
});
const matchDispatchToProps = dispatch => bindActionCreators({ _handleUserRegistration }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(SignUp);
